import { MODULES } from "@/config/modules";

export default {
  isEnabled: (_, __, ___, rootGetters) => {
    return rootGetters["modules/getEnabledModules"][MODULES.INVEST_PLANS];
  },
};
